export function updateGenericDataBox3(genericData) {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_GENERIC_DATA_BOX_3',
      genericData,
    })
  }
}
